import request from '@/utils/request'

//访问相关业务的数据接口


//加载可以进行匹配关联的 教辅书列表
export function load_books() {
    return request({
        url: '/edas/datas/books',
        method: 'get',
        params: ''
    })
}

//创建新的关联关系
export function new_relate_book(anBookId,anBookName,xrBookId,xrBookName) {
    return request({
        url: '/edas/datas/relate',
        method: 'post',
        data: {
            anBookId : anBookId,
            anBookName : anBookName,
            xrBookId : xrBookId,
            xrBookName : xrBookName
        }
    })
}


//创建新的关联关系
export function un_relate_book(anBookId) {
    return request({
        url: '/edas/datas/relate_remove',
        method: 'post',
        data: {
            anBookId : anBookId
        }
    })
}


//加载已经被暗物识别处理过的页面分析数据
export function load_datas_pages(anBookId) {
    return request({
        url: '/edas/datas/pages',
        method: 'post',
        header:{'Content-Type':'application/json'},
        data: {
            bookid : anBookId
        }
    })
}

//加载已经被暗物识别处理过的页面分析数据
export function load_page_ocr_detail(anBookId,pageCode) {
    return request({
        url: '/edas/datas/page_ocr',
        method: 'post',
        header:{'Content-Type':'application/json'},
        data: {
            bookid : anBookId,
            pageCode : pageCode
        }
    })
}

//加载已完成关联编辑的页面数据，用来区分哪些题目已经是成功编辑录入的
export function load_page_video_done(anBookId,pageCode) {
    return request({
        url: '/edas/datas/video_done',
        method: 'post',
        header:{'Content-Type':'application/json'},
        data: {
            anBookId : anBookId,
            pageCode : pageCode
        }
    })
}


//查找小睿已经录入的视频视频 题目信息
export function load_page_videos(xrBookId,pageCode,filter) {
    return request({
        url: '/edas/datas/videos',
        method: 'post',
        header:{'Content-Type':'application/json'},
        data: {
            xrBookId : xrBookId,
            pageCode : pageCode,
            filter : filter
        }
    })
}

// 给目标的题目绑定对应的视频内容
export function bind_video(anBookId,pageCode,grade,term,subject,questionCode,videoUrl,videoName,videoFm,analysisUrl) {
    return request({
        url: '/edas/datas/bindvideo',
        method: 'post',
        header:{'Content-Type':'application/json'},
        data: {
            anBookId : anBookId,
            pageCode : pageCode,
            grade : grade,
            questionCode : questionCode,
            videoUrl : videoUrl,
            videoName : videoName,
            videoFm : videoFm,
            analysisUrl : analysisUrl,
            term : term,
            subject : subject
        }
    })
}


// 给目标的题目绑定对应的视频内容
export function unbind_video(anBookId,pageCode,questionCode) {
    return request({
        url: '/edas/datas/unbindvideo',
        method: 'post',
        header:{'Content-Type':'application/json'},
        data: {
            anBookId : anBookId,
            pageCode : pageCode,
            questionCode : questionCode
        }
    })
}


//标记某个页面数据的处理状态，是否已经完成
export function page_status_flag(anBookId,pageCode,status) {
    return request({
        url: '/edas/datas/page_status_flag',
        method: 'post',
        header:{'Content-Type':'application/json'},
        data: {
            anBookId : anBookId,
            pageCode : pageCode,
            status : status
        }
    })
}

//页面的处理编辑状态
export function page_status(anBookId,pageCode) {
    return request({
        url: '/edas/datas/page_status',
        method: 'post',
        header:{'Content-Type':'application/json'},
        data: {
            anBookId : anBookId
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/edas.js